import { useVectorModal } from "../../../hooks/useVectorMemoryModal"

import { Button, type ButtonProps, CircularProgress } from "@mui/material"

interface VectorModalButtonProps extends ButtonProps {}

function VectorModalButton(props: VectorModalButtonProps) {
	const {
		isEditing,

		onNamespaceCreate,
		onNamespaceUpdate,
	} = useVectorModal()

	return (
		<Button
			variant="contained"
			onClick={() => isEditing
				? onNamespaceUpdate()
				: onNamespaceCreate()
			}
			{...props}
		/>
	)
}

interface VectorModalButtonLabelProps {
	buttonStatus: ButtonLabelTextStates
}

const editingLabels = {
	idle: 'Update Memory Pod',
	pending: (
		<div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
			<CircularProgress color="inherit" size={16} />
			Updating Memory Pod
		</div>
	),
	error: 'Something went wrong',
	success: 'Memory Pod Updated!'
}

const creatingLabels = {
	idle: 'Create Memory Pod',
	pending: (
		<div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
			<CircularProgress color="inherit" size={16} />
			Creating Memory Pod
		</div>
	),
	error: 'Something went wrong',
	success: 'Memory Pod Created!'
}

type ButtonLabelTextStates = keyof typeof creatingLabels

function VectorModalButtonLabel({
	buttonStatus,
}: VectorModalButtonLabelProps) {
	const { isEditing } = useVectorModal()

	if (isEditing) {
		return editingLabels[buttonStatus]
	}

	return creatingLabels[buttonStatus]
}

export { VectorModalButton, VectorModalButtonLabel }